module.exports = function() {
  return new Worker(__webpack_public_path__ + "f5fcd85af3de7744bbca.worker.js");
};